import * as i0 from '@angular/core';
import { Injectable, ElementRef, Component, Input, ViewChildren, forwardRef, EventEmitter, Directive, Optional, Inject, HostBinding, Output, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { of, Subject, merge, fromEvent } from 'rxjs';
import { catchError, filter, tap, map, debounceTime, switchMap } from 'rxjs/operators';
import * as i1$1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1$2 from '@am/moebius';
import { MbIconModule } from '@am/moebius';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i2 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { aciNeighborhood, aciHotels, aciPointer, aciFlights, aciPrivateBeach } from '@am/common-svg-icons';

class AmAutocompleteService {
    constructor(http) {
        this.http = http;
    }
    fetchSuggestions(url, query) {
        console.time('get API');
        var result = this.http.get(`${url}${query}`).pipe(catchError(() => of([])));
        console.timeEnd('get API');
        return result;
    }
}
/** @nocollapse */ AmAutocompleteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ AmAutocompleteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

var EntityTypes;
(function (EntityTypes) {
    EntityTypes["hotel"] = "Hotel";
    EntityTypes["city"] = "Ciudad";
    EntityTypes["neighborhood"] = "Barrio";
    EntityTypes["airport"] = "Aeropuerto";
    EntityTypes["point_of_interest"] = "Punto de inter\u00E9s";
    EntityTypes["touristicregion"] = "Zona Tur\u00EDstica";
})(EntityTypes || (EntityTypes = {}));
function isEntity(obj) {
    return typeof obj === 'object' && obj !== null && obj.id && obj.label && 'code' in obj;
}

class AmAutocompleteComponent {
    constructor() {
        this.valueSelected$ = new Subject();
        this.selectedIndex = 0;
    }
    selectOption(entity, group) {
        this.valueSelected$.next({
            group,
            ...entity,
        });
    }
    get EntityTypes() {
        return EntityTypes;
    }
    isSelected(globalIndex) {
        return globalIndex === this.selectedIndex;
    }
    moveSelectionUp() {
        if (this.selectedIndex > 0) {
            this.selectedIndex--;
            this.scrollToSelected();
        }
    }
    moveSelectionDown() {
        const total = this.autocompleteItems.length;
        if (this.selectedIndex < total - 1) {
            this.selectedIndex++;
            this.scrollToSelected();
        }
    }
    selectCurrentItem() {
        const itemsArray = this.autocompleteItems.toArray();
        const item = itemsArray[this.selectedIndex];
        if (item && item.nativeElement) {
            item.nativeElement.click();
        }
    }
    scrollToSelected() {
        const itemsArray = this.autocompleteItems.toArray();
        const selected = itemsArray[this.selectedIndex];
        if (selected) {
            selected.nativeElement.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
    }
    getGlobalIndex(groupIndex, itemIndex) {
        let count = 0;
        for (let i = 0; i < groupIndex; i++) {
            count += this.suggestions[i].entities.length;
        }
        return count + itemIndex;
    }
    getActiveDescendantId() {
        return 'autocomplete-option-' + this.selectedIndex;
    }
    stripHtmlTags(html) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || '';
    }
}
/** @nocollapse */ AmAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ AmAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AmAutocompleteComponent, selector: "am-autocomplete", inputs: { suggestions: "suggestions" }, viewQueries: [{ propertyName: "autocompleteItems", predicate: ["autocompleteItem"], descendants: true, read: ElementRef }], ngImport: i0, template: "<div class=\"autocomplete_wrapper\">\n  <div class=\"autocomplete_wrapper_triangle\"></div>\n  <ul class=\"autocomplete\" role=\"listbox\" id=\"autocomplete-listbox\">\n    <li\n      role=\"group\"\n      [attr.aria-labelledby]=\"'group-label-' + groupIndex\"\n      *ngFor=\"let groups of suggestions; let groupIndex = index\"\n    >\n      <div class=\"autocomplete_header\">\n        <mb-icon class=\"autocomplete_icon\" [icon]=\"'autocomplete:' + groups.group\"></mb-icon>\n        <span class=\"autocomplete_title\" [id]=\"'group-label-' + groupIndex\">\n          {{ EntityTypes[groups.group] }}\n        </span>\n        <div class=\"autocomplete_separator\"></div>\n      </div>\n\n      <ul class=\"autocomplete_items\">\n        <li\n          #autocompleteItem\n          class=\"autocomplete_item\"\n          role=\"option\"\n          [id]=\"'autocomplete-option-' + getGlobalIndex(groupIndex, i)\"\n          [attr.aria-selected]=\"isSelected(getGlobalIndex(groupIndex, i))\"\n          [attr.aria-label]=\"EntityTypes[groups.group] + ', ' + stripHtmlTags(entity.label)\"\n          [innerHTML]=\"entity.label\"\n          (click)=\"selectOption(entity, groups.group)\"\n          [class.selected]=\"isSelected(getGlobalIndex(groupIndex, i))\"\n          tabindex=\"-1\"\n          *ngFor=\"let entity of groups.entities; let i = index\"\n        ></li>\n      </ul>\n    </li>\n  </ul>\n</div>\n\n", styles: [".autocomplete{background:var(--color-white);border:solid 1px var(--color-gray-700);border-radius:4px;list-style:none;margin:0;padding:16px}.autocomplete_wrapper_triangle{border-bottom:7px solid var(--color-gray-700);border-left:12px solid transparent;border-right:12px solid transparent;height:0;left:5px;position:absolute;top:-6px;width:0}.autocomplete_wrapper_triangle:before{border-bottom:6px solid var(--color-white);border-left:10px solid transparent;border-right:10px solid transparent;content:\"\";height:0;left:-10px;position:absolute;top:1px;width:0}.autocomplete_suggestion-wrapper{margin-bottom:24px}.autocomplete_suggestion-wrapper.last-child{margin-bottom:0}.autocomplete_icon{bottom:2px;color:var(--color-secondary);font-size:18px;position:relative}.autocomplete_header{padding:8px}.autocomplete_separator{border-bottom:1px solid var(--color-gray);margin:8px 0 0}.autocomplete_title{color:var(--color-gray-800);margin-left:8px;font-size:1rem;font-weight:var(--font-weight-semibold);line-height:1.5}@media only screen and (max-width: 767px){.autocomplete_title{line-height:1.5}}.autocomplete_items{margin:0 8px;padding:0}.autocomplete_item{color:var(--color-gray-800);cursor:pointer;list-style:none;margin:4px 0 4px 24px;font-size:1rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.autocomplete_item{line-height:1.5}}.autocomplete_item::ng-deep mark{background-color:inherit;color:var(--color-secondary)}.autocomplete_item:hover{background:var(--color-secondary-clear)}.autocomplete .autocomplete_item.selected{background-color:var(--color-secondary-clear)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i1$2.MbIcon, selector: "mb-icon", inputs: ["icon", "horizontalFlip", "verticalFlip", "spin"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-autocomplete', template: "<div class=\"autocomplete_wrapper\">\n  <div class=\"autocomplete_wrapper_triangle\"></div>\n  <ul class=\"autocomplete\" role=\"listbox\" id=\"autocomplete-listbox\">\n    <li\n      role=\"group\"\n      [attr.aria-labelledby]=\"'group-label-' + groupIndex\"\n      *ngFor=\"let groups of suggestions; let groupIndex = index\"\n    >\n      <div class=\"autocomplete_header\">\n        <mb-icon class=\"autocomplete_icon\" [icon]=\"'autocomplete:' + groups.group\"></mb-icon>\n        <span class=\"autocomplete_title\" [id]=\"'group-label-' + groupIndex\">\n          {{ EntityTypes[groups.group] }}\n        </span>\n        <div class=\"autocomplete_separator\"></div>\n      </div>\n\n      <ul class=\"autocomplete_items\">\n        <li\n          #autocompleteItem\n          class=\"autocomplete_item\"\n          role=\"option\"\n          [id]=\"'autocomplete-option-' + getGlobalIndex(groupIndex, i)\"\n          [attr.aria-selected]=\"isSelected(getGlobalIndex(groupIndex, i))\"\n          [attr.aria-label]=\"EntityTypes[groups.group] + ', ' + stripHtmlTags(entity.label)\"\n          [innerHTML]=\"entity.label\"\n          (click)=\"selectOption(entity, groups.group)\"\n          [class.selected]=\"isSelected(getGlobalIndex(groupIndex, i))\"\n          tabindex=\"-1\"\n          *ngFor=\"let entity of groups.entities; let i = index\"\n        ></li>\n      </ul>\n    </li>\n  </ul>\n</div>\n\n", styles: [".autocomplete{background:var(--color-white);border:solid 1px var(--color-gray-700);border-radius:4px;list-style:none;margin:0;padding:16px}.autocomplete_wrapper_triangle{border-bottom:7px solid var(--color-gray-700);border-left:12px solid transparent;border-right:12px solid transparent;height:0;left:5px;position:absolute;top:-6px;width:0}.autocomplete_wrapper_triangle:before{border-bottom:6px solid var(--color-white);border-left:10px solid transparent;border-right:10px solid transparent;content:\"\";height:0;left:-10px;position:absolute;top:1px;width:0}.autocomplete_suggestion-wrapper{margin-bottom:24px}.autocomplete_suggestion-wrapper.last-child{margin-bottom:0}.autocomplete_icon{bottom:2px;color:var(--color-secondary);font-size:18px;position:relative}.autocomplete_header{padding:8px}.autocomplete_separator{border-bottom:1px solid var(--color-gray);margin:8px 0 0}.autocomplete_title{color:var(--color-gray-800);margin-left:8px;font-size:1rem;font-weight:var(--font-weight-semibold);line-height:1.5}@media only screen and (max-width: 767px){.autocomplete_title{line-height:1.5}}.autocomplete_items{margin:0 8px;padding:0}.autocomplete_item{color:var(--color-gray-800);cursor:pointer;list-style:none;margin:4px 0 4px 24px;font-size:1rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.autocomplete_item{line-height:1.5}}.autocomplete_item::ng-deep mark{background-color:inherit;color:var(--color-secondary)}.autocomplete_item:hover{background:var(--color-secondary-clear)}.autocomplete .autocomplete_item.selected{background-color:var(--color-secondary-clear)}\n"] }]
        }], propDecorators: { suggestions: [{
                type: Input
            }], autocompleteItems: [{
                type: ViewChildren,
                args: ['autocompleteItem', { read: ElementRef }]
            }] } });

const AM_AUTOCOMPLETE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AmAutocompleteDirective),
    multi: true,
};
class AmAutocompleteDirective {
    constructor(elementRef, autocompleteService, overlay, _document) {
        this.elementRef = elementRef;
        this.autocompleteService = autocompleteService;
        this.overlay = overlay;
        this._document = _document;
        this.valueChange = new EventEmitter();
        this.valueOnChange = (value) => { };
        this.valueOnTouched = () => { };
        this.hasFocus = false;
        this.hasSearchableText = false;
    }
    set value(value) {
        if (isEntity(value) || !value) {
            this._writeValueInInput(value);
            this._value = value ? value : null;
        }
    }
    get value() {
        return this._value;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    get disabled() {
        return this._disabled;
    }
    _setUpOutsideClickSubscription() {
        this.ouputSideClickSubscription = merge(fromEvent(this._document, 'click'), fromEvent(this._document, 'touchend'))
            .pipe(filter(event => {
            const clickTarget = event.target;
            return (clickTarget !== this.elementRef.nativeElement &&
                this._isElementOutsideOverlay(clickTarget));
        }), tap(() => (this.hasFocus = false)), tap(() => this.close()))
            .subscribe(() => this._writeValueInInput(this.value));
    }
    _isElementOutsideOverlay(element) {
        if (!this.autocompleteOverlay) {
            // double check for border case
            return this._document.contains(element);
        }
        else {
            return !this.autocompleteOverlay.overlayElement.contains(element);
        }
    }
    click(target) {
        if (this.value) {
            target.setSelectionRange(0, this.elementRef.nativeElement.value.length);
        }
    }
    ngOnInit() {
        this._setUpOutsideClickSubscription();
        this._setupInputCloseSubscription();
        this._setupInputOpenSubscription();
        this._setupInputFocusOutSubscription();
        this._setupKeyboardNavigationSubscription();
        this._addAriaAttributesToInput();
    }
    _addAriaAttributesToInput() {
        const inputEl = this.elementRef.nativeElement;
        inputEl.setAttribute('role', 'combobox');
        inputEl.setAttribute('aria-autocomplete', 'list');
        inputEl.setAttribute('aria-haspopup', 'listbox');
        inputEl.setAttribute('aria-expanded', 'false');
        inputEl.setAttribute('aria-controls', 'autocomplete-listbox');
    }
    _setupInputOpenSubscription() {
        this.inputKeyUpOpenSubscription = fromEvent(this.elementRef.nativeElement, 'keyup')
            .pipe(filter(event => !['ArrowDown', 'ArrowUp', 'Escape'].includes(event.key)), map(event => event.target.value.trim()), // Project the text from the input
        tap(text => (this.hasSearchableText = text.length > 2)), filter(text => text.length > 2), tap(() => (this.hasFocus = true)), debounceTime(300), switchMap(value => this.autocompleteService.fetchSuggestions(this.url, value)), filter(() => this.hasFocus && this.hasSearchableText))
            .subscribe(suggestions => {
            if (suggestions.length > 0) {
                this.open(suggestions);
            }
        });
    }
    _setupInputFocusOutSubscription() {
        this.inputFocusOutSubscription = fromEvent(this.elementRef.nativeElement, 'keydown')
            .pipe(filter(({ code }) => code === 'Tab'), tap(() => (this.hasFocus = false)), tap(() => this.close()))
            .subscribe(() => this._writeValueInInput(this.value));
    }
    _setupInputCloseSubscription() {
        this.inputKeyUpCloseSubscription = fromEvent(this.elementRef.nativeElement, 'keyup')
            .pipe(map(event => event.target.value.trim()), // Project the text from the input
        filter(text => text.length < 3))
            .subscribe(() => this.close());
    }
    _setupKeyboardNavigationSubscription() {
        this.keyboardNavigationSubscription = fromEvent(this.elementRef.nativeElement, 'keydown')
            .pipe(filter(() => this.openend))
            .subscribe(event => {
            let componentRef = null;
            if (this.portalComponentRef) {
                componentRef = this.portalComponentRef.instance;
            }
            if (!componentRef)
                return;
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    componentRef.moveSelectionDown();
                    this._updateActiveDescendant(componentRef);
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    componentRef.moveSelectionUp();
                    this._updateActiveDescendant(componentRef);
                    break;
                case 'Enter':
                    event.preventDefault();
                    componentRef.selectCurrentItem();
                    break;
                case 'Escape':
                    event.preventDefault();
                    this.close();
                    break;
            }
        });
    }
    _updateActiveDescendant(component) {
        const inputEl = this.elementRef.nativeElement;
        inputEl.setAttribute('aria-activedescendant', component.getActiveDescendantId());
    }
    ngOnDestroy() {
        this.ouputSideClickSubscription.unsubscribe();
        this.inputKeyUpCloseSubscription.unsubscribe();
        this.inputKeyUpOpenSubscription.unsubscribe();
        this.inputFocusOutSubscription.unsubscribe();
        this.keyboardNavigationSubscription.unsubscribe();
    }
    open(val) {
        this.close();
        const inputEl = this.elementRef.nativeElement;
        inputEl.setAttribute('aria-expanded', 'true');
        inputEl.setAttribute('aria-activedescendant', 'autocomplete-option-0');
        console.time('autocomplete.directive: new ComponentPortal');
        this.calendarPortal = new ComponentPortal(AmAutocompleteComponent);
        console.timeEnd('autocomplete.directive: new ComponentPortal');
        console.time('autocomplete.directive: this.getPositionStrategy');
        const positionStrategy = this.getPositionStrategy();
        console.timeEnd('autocomplete.directive: this.getPositionStrategy');
        console.time('autocomplete.directive: this.overlay.create');
        this.autocompleteOverlay = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            backdropClass: 'am-overlay-transparent-backdrop',
            hasBackdrop: true,
        });
        console.timeEnd('autocomplete.directive: this.overlay.create');
        console.time('autocomplete.directive: this.autocompleteOverlay.backdropClick()');
        this.autocompleteOverlay.backdropClick().subscribe(() => {
            this.close();
            !this.value && this.writeValue(this.value);
        });
        console.timeEnd('autocomplete.directive: this.autocompleteOverlay.backdropClick()');
        console.time('autocomplete.directive: this.calendarPortal.attach');
        this.portalComponentRef = this.calendarPortal.attach(this.autocompleteOverlay);
        console.timeEnd('autocomplete.directive: this.calendarPortal.attach');
        this.portalComponentRef.instance.suggestions = val;
        console.time('autocomplete.directive: portalComponentRef.instance.valueSelected$.subscribe');
        this.portalComponentRef.instance.valueSelected$.subscribe(value => {
            this.value = value;
            this.valueOnChange(value);
            this.valueChange.emit(value);
            this.valueOnTouched();
            this.close();
        });
        console.timeEnd('autocomplete.directive: portalComponentRef.instance.valueSelected$.subscribe');
        this.openend = true;
    }
    getPositionStrategy() {
        return this.overlay
            .position()
            .flexibleConnectedTo(this.elementRef)
            .withLockedPosition()
            .withFlexibleDimensions(false)
            .withPositions([
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
            },
        ]);
    }
    _writeValueInInput(val) {
        this.elementRef.nativeElement.value = val
            ? val.label.replace(/<[^>]+>/gm, '')
            : '';
    }
    close() {
        if (this.autocompleteOverlay && this.autocompleteOverlay.hasAttached()) {
            this.autocompleteOverlay.detach();
            this.autocompleteOverlay = null;
        }
        if (this.calendarPortal && this.calendarPortal.isAttached) {
            this.calendarPortal.detach();
        }
        const inputEl = this.elementRef.nativeElement;
        inputEl.setAttribute('aria-expanded', 'false');
        inputEl.removeAttribute('aria-activedescendant');
        this.openend = false;
    }
    // ControlValueAccessor methods
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this.valueOnChange = fn;
    }
    registerOnTouched(fn) {
        this.valueOnTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
/** @nocollapse */ AmAutocompleteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteDirective, deps: [{ token: i0.ElementRef }, { token: AmAutocompleteService }, { token: i2.Overlay }, { token: DOCUMENT, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ AmAutocompleteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: AmAutocompleteDirective, selector: "input[amAutocomplete]", inputs: { value: "value", disabled: "disabled", url: "url" }, outputs: { valueChange: "valueChange" }, host: { listeners: { "click": "click($event.target)" }, properties: { "disabled": "this.disabled" } }, providers: [AM_AUTOCOMPLETE_VALUE_ACCESSOR], exportAs: ["amAutocomplete"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[amAutocomplete]',
                    providers: [AM_AUTOCOMPLETE_VALUE_ACCESSOR],
                    exportAs: 'amAutocomplete',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: AmAutocompleteService }, { type: i2.Overlay }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { value: [{
                type: Input
            }], disabled: [{
                type: HostBinding,
                args: ['disabled']
            }, {
                type: Input
            }], url: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], click: [{
                type: HostListener,
                args: ['click', ['$event.target']]
            }] } });

const ICONS_NAMESPACE = 'autocomplete';
class AmAutocompleteModule {
    constructor(iconsRegistry) {
        iconsRegistry.addSvgIconDefinitionInNamespace(aciNeighborhood, ICONS_NAMESPACE);
        iconsRegistry.addSvgIconDefinitionInNamespaceWithAliases(aciHotels, ICONS_NAMESPACE, ['hotel']);
        iconsRegistry.addSvgIconDefinitionInNamespaceWithAliases(aciPointer, ICONS_NAMESPACE, [
            'point_of_interest',
        ]);
        iconsRegistry.addSvgIconDefinitionInNamespaceWithAliases(aciPointer, ICONS_NAMESPACE, ['city']);
        iconsRegistry.addSvgIconDefinitionInNamespaceWithAliases(aciFlights, ICONS_NAMESPACE, [
            'airport',
        ]);
        iconsRegistry.addSvgIconDefinitionInNamespaceWithAliases(aciPrivateBeach, ICONS_NAMESPACE, [
            'touristicregion',
        ]);
    }
}
/** @nocollapse */ AmAutocompleteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteModule, deps: [{ token: i1$2.MbIconRegistry }], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ AmAutocompleteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteModule, declarations: [AmAutocompleteComponent, AmAutocompleteDirective], imports: [CommonModule, FormsModule, OverlayModule, MbIconModule], exports: [AmAutocompleteComponent, AmAutocompleteDirective] });
/** @nocollapse */ AmAutocompleteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteModule, providers: [AmAutocompleteService], imports: [CommonModule, FormsModule, OverlayModule, MbIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmAutocompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AmAutocompleteComponent, AmAutocompleteDirective],
                    imports: [CommonModule, FormsModule, OverlayModule, MbIconModule],
                    exports: [AmAutocompleteComponent, AmAutocompleteDirective],
                    providers: [AmAutocompleteService],
                    entryComponents: [AmAutocompleteComponent],
                }]
        }], ctorParameters: function () { return [{ type: i1$2.MbIconRegistry }]; } });

/*
 * Public API Surface of autocomplete
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AM_AUTOCOMPLETE_VALUE_ACCESSOR, AmAutocompleteComponent, AmAutocompleteDirective, AmAutocompleteModule, AmAutocompleteService };
